<template>
  <div class="container mt-4">
    <h2>Cadastro de Produto</h2>
    <div class="top-menu">
      <BaseInputLogic
        style="margin-bottom: 13px"
        :options="menu.options"
        :value.sync="menu.value"
        @onDataChange="handleInputChange(menu.value)"
      ></BaseInputLogic>
    </div>

    <div v-if="menu.value == '1'">
      <b-form @submit.prevent="submitForm">
        <b-row>
          <b-col cols="8">
            <b-form-group label-for="name" label="Nome">
              <b-form-input
                v-model="product.name"
                type="text"
                id="name"
                placeholder="Informe o nome do produto"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="4">
            <b-form-group label-for="code" label="Código">
              <b-form-input
                v-model="product.code"
                type="text"
                id="code"
                :state="product.code != null && product.code.trim().length > 0"
                placeholder="Informe o código do produto"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="8">
            <b-form-group label-for="barcode" label="Código de Barras">
              <b-form-input
                v-model="product.barCode"
                type="text"
                id="barcode"
                placeholder="Informe o código de barras"
                required
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label-for="price" label="Preço">
              <base-input-numeric
                :value.sync="product.price"
              ></base-input-numeric>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <b-form-group label-for="unit" label="Unidade de Medida">
              <b-form-select
                v-model="product.unit"
                :options="unitOptions"
                id="unit"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label-for="description" label="Descrição">
              <b-form-textarea
                v-model="product.description"
                id="description"
                placeholder="Informe a descrição"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <hr />
        <h3>Estoque</h3>

        <b-row>
          <b-col cols="4">
            <b-form-group label-for="availableQty" label="Qtd. Disponível">
              <b-form-input
                v-model.number="product.availableQty"
                type="number"
                id="availableQty"
                :state="product.availableQty > 0"
                placeholder="Informe a quantidade disponível"
                min="0"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="4">
            <b-form-group label-for="reservedQty" label="Qtd. Reservada">
              <b-form-input
                v-model.number="product.reservedQty"
                type="number"
                id="reservedQty"
                placeholder="Informe a quantidade reservada"
                min="0"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="4">
            <b-form-group label-for="totalQty" label="Qtd. Total">
              <b-form-input
                :value="totalQty"
                type="number"
                id="totalQty"
                disabled="true"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label-for="productFamily" label="Familia de Produto">
              <b-form-select
                v-model="product.productFamilyId"
                :options="productFamilyOptions"
                id="productFamily"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-for="category" label="Categoria">
              <b-form-select
                v-model="product.category"
                :options="categoryOptions"
                id="category"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-for="productType" label="Tipo do Produto">
              <b-form-select
                v-model="product.productType"
                :options="productTypeOptions"
                :state="!!product.productType"
                id="productType"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-for="cost" label="Custo médio">
              <base-input-numeric
                :value.sync="product.cost"
              ></base-input-numeric>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="product.productFamilyId == 'new'">
          <b-col>
            <b-form-group label-for="name" label="Nome Familia de Produto">
              <b-form-input
                v-model="newProductFamily.name"
                type="text"
                id="name"
                placeholder="Informe o nome do produto"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-for="name" label="Código de Produto">
              <b-form-input
                v-model="newProductFamily.code"
                type="text"
                id="name"
                placeholder="Informe o nome do produto"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-button
              variant="primary"
              class="mt-4"
              block
              @click="addNewProductFamily"
            >
              Salvar
            </b-button>
          </b-col>
        </b-row>
        <hr />
        <b-collapse id="collapse-tax" v-model="collapsetax">
          <h3>
            Dados Fiscais
          </h3>
          <b-row>
            <b-col>
              <b-form-group
                label-for="cest"
                label="CEST(Código Especificador da Substituição Tributária)"
              >
                <b-form-input
                  v-model="product.cest"
                  type="text"
                  id="cest"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-group
                label-for="ncm"
                label="NCM(Nomenclattura Comum do Mercosul)"
              >
                <b-form-input
                  v-model="product.ncm"
                  type="text"
                  id="ncm"
                  required
                  v-mask="'9999.99.99'"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-group label-for="origin" label="Origem">
                <b-form-select
                  v-model="product.origin"
                  :options="originOptions"
                  id="origin"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <h4>Regras por NCM</h4>
          <b-table
            striped
            bordered
            hover
            :items="product.taxRulesNcm"
            :fields="fiscalRuleFields"
            class="mt-3"
          >
          </b-table>

          <b-button
            variant="primary"
            class="mt-3"
            size="sm"
            @click="togglePanel"
          >
            Adicionar Regra
          </b-button>
          <SidePanel
            :isPanelOpen="openPanel"
            :product="product"
            :isProductRule="false"
            :stateOptions="stateOptions"
            @tax-rule-ncm="addTaxRuleNcm"
            @close-sidepanel="togglePanel"
          ></SidePanel>

          <b-pagination
            v-model="currentPage"
            :total-rows="product.taxRulesNcm.length"
            :per-page="perPage"
            align="center"
            class="mt-2"
          >
          </b-pagination>

          <hr />

          <h4>Regras por Produto</h4>
          <b-table
            striped
            bordered
            hover
            :items="product.taxRulesProduct"
            :fields="fiscalRuleProdFields"
            class="mt-3"
          >
          </b-table>

          <b-button
            variant="primary"
            class="mt-3"
            size="sm"
            @click="togglePanelTaxRuleProd"
          >
            Adicionar Regra
          </b-button>
          <SidePanel
            :isPanelOpen="openTaxRuleProdPanel"
            :isProductRule="true"
            :product="product"
            :stateOptions="stateOptions"
            @tax-rule-product="addTaxRuleProduct"
            @close-sidepanel="togglePanelTaxRuleProd"
          ></SidePanel>

          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            align="center"
            class="mt-2"
          >
          </b-pagination>
        </b-collapse>

        <b-button variant="primary" @click="addNewProduct">
          Salvar
        </b-button>

        <fade-alert-danger
          ref="fadeAlertDanger"
          :msg="alert.error"
        ></fade-alert-danger>
        <success-fade-alert
          ref="successFadeAlert"
          :msg="alert.success"
        ></success-fade-alert>
      </b-form>
    </div>
  </div>
</template>

<script>
import SidePanel from "../../Components/SidePanel.vue";
import BaseInputLogic from "../../../../components_rms/base/BaseImputLogic.vue";
import BaseInputNumeric from "../../../../components_rms/base/BaseInputNumeric.vue";
import AwesomeMask from "awesome-mask";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
export default {
  name: "ProductCrud",
  components: {
    SidePanel,
    BaseInputLogic,
    BaseInputNumeric,
    FadeAlertDanger,
    SuccessFadeAlert
  },
  directives: {
    mask: AwesomeMask
  },
  created() {
    if (this.$route?.params?.rowData)
      this.product = JSON.parse(this.$route.params.rowData);

    this.getAllProductFamilies();
  },
  data() {
    return {
      collapsetax: false,
      rowData: null,
      openPanel: false,
      openTaxRuleProdPanel: false,
      perPage: 4,
      taxRulesProduct: [],
      currentPage: 1,
      stateOptions: [],
      product: {
        id: null,
        name: null,
        code: null,
        barCode: "",
        price: 0,
        unit: "",
        description: "",
        availableQty: 0,
        reservedQty: 0,
        totalQty: 0,
        productFamilyId: null,
        category: "",
        cost: 0,
        type: 0,
        sku: "6",
        cest: "",
        ncm: "",
        productType: null,
        origin: 0,
        taxRulesNcm: [],
        taxRulesProduct: []
      },
      productFamily: {
        id: null,
        name: "",
        code: "",
        products: []
      },
      taxRuleNcm: {
        id: null,
        name: "",
        ncmCode: "",
        operationNature: 0,
        icmsSt: [],
        fcps: [],
        pisCofinsTaxSituation: 0,
        pisAliquot: 0,
        cofinsAliquot: 0,
        productId: 0
      },
      taxRuleProduct: {
        id: null,
        name: "",
        productCode: "",
        operationNature: 0,
        icmsSt: [],
        fcps: [],
        pisCofinsTaxSituation: 0,
        pisAliquot: 0,
        cofinsAliquot: 0,
        productId: 0
      },
      icmsSt: {
        id: null,
        EstadoId: "",
        Estado: {
          id: null,
          Name: ""
        },
        icmsAliquot: 0,
        icmsReduction: 0,
        icmsStReduction: 0,
        mva: 0,
        icmsStAliquot: 0,
        taxRuleNcmId: null,
        taxRuleProductId: null
      },
      fcp: {
        id: null,
        estadoId: null,
        estado: {
          id: null,
          name: ""
        },
        fcp: 0,
        fcpSt: 0,
        taxRuleNcmId: 0,
        taxRuleProductId: 0
      },
      unitOptions: [
        {
          label: "Unidades básicas",
          options: [
            { value: "un", text: "un - unidade" },
            { value: "pc", text: "pc - peça" },
            { value: "kg", text: "kg - quilograma" },
            { value: "g", text: "g - grama" },
            { value: "m", text: "m - metro" },
            { value: "cm", text: "cm - centímetro" },
            { value: "mm", text: "mm - milímetro" }
          ]
        },
        {
          label: "Volume",
          options: [
            { value: "l", text: "l - litro" },
            { value: "ml", text: "ml - mililitro" },
            { value: "m3", text: "m³ - metro cúbico" }
          ]
        },
        {
          label: "Área",
          options: [
            { value: "m2", text: "m² - metro quadrado" },
            { value: "cm2", text: "cm² - centímetro quadrado" }
          ]
        },
        {
          label: "Tempo",
          options: [
            { value: "h", text: "h - hora" },
            { value: "min", text: "min - minuto" }
          ]
        },
        {
          label: "Embalagens e formatos comerciais",
          options: [
            { value: "cx", text: "cx - caixa" },
            { value: "pct", text: "pct - pacote" },
            { value: "fd", text: "fd - fardo" },
            { value: "rl", text: "rl - rolo" },
            { value: "lt", text: "lt - lata" },
            { value: "fr", text: "fr - frasco" }
          ]
        },
        {
          label: "Diversos",
          options: [
            { value: "par", text: "par - par" },
            { value: "dz", text: "dz - dúzia" },
            { value: "sc", text: "sc - saco" },
            { value: "cj", text: "cj - conjunto" },
            { value: "amp", text: "amp - ampola" },
            { value: "bl", text: "bl - bloco" }
          ]
        },
        {
          label: "Genérica",
          options: [{ value: "other", text: "Outra - outra unidade" }]
        }
      ],
      newProductFamily: {
        id: null,
        name: "",
        code: ""
      },
      productFamilyOptions: [{ value: "new", text: "Novo" }],
      categoryOptions: [
        { value: "0", text: "Ativo Imobilizado" },
        { value: "1", text: "Embalagem" },
        { value: "2", text: "Material de Uso e Consumo" },
        { value: "3", text: "Matéria Prima" },
        { value: "4", text: "Mercadoria para Revenda" },
        { value: "5", text: "Outros insumos" },
        { value: "6", text: "Produto Acabado" },
        { value: "7", text: "Produto semi acabado" },
        { value: "99", text: "Outras" }
      ],
      productTypeOptions: [
        { value: null, text: "Selecione o tipo" },
        { value: "0", text: "Mercadoria para Revenda" },
        { value: "1", text: "Matéria Prima" },
        { value: "2", text: "Embalagem" },
        { value: "3", text: "Produto em Processo" },
        { value: "4", text: "Produto Acabado" },
        { value: "5", text: "Subproduto" },
        { value: "6", text: "Produto intermediário" },
        { value: "7", text: "Material de Uso e Consumo" },
        { value: "8", text: "Ativo Imobilizado" },
        { value: "9", text: "Serviços" },
        { value: "10", text: "Outros insumos" },
        { value: "99", text: "Outras" }
      ],
      originOptions: [
        { value: "0", text: "Nacional" },
        { value: "1", text: "Estrangeira - Importação Direta" },
        { value: "2", text: "Estrangeira - Adquirida no mercado interno" },
        {
          value: "3",
          text:
            "Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40%"
        },
        {
          value: "4",
          text:
            "Nacional, cuja produção tenha sido feita em conformidade com a MP 252(MP do Bem)"
        },
        {
          value: "5",
          text:
            "Nacional, mercadoria ou bem com Conteúdo de importação inferior a 40%"
        },
        {
          value: "6",
          text:
            "Estrangeira - Importação direta, sem similar nacional, constante em lista de Resolução CAMEX"
        },
        {
          value: "7",
          text:
            "Estrangeira - Adquirida no mercado interno, sem similar nacional, constante em lista de Resolução CAMEX"
        },
        {
          value: "8",
          text:
            "Nacional, mercadoria ou bem com Conteúdo de Importação superior a 70%"
        }
      ],
      fiscalRuleFields: [
        { key: "name", label: "Regra Fiscal" },
        { key: "operationNature", label: "Natureza" },
        { key: "ncmCode", label: "NCM" },
        { key: "priority", label: "Prioridade" }
      ],
      fiscalRuleProdFields: [
        { key: "name", label: "Regra Fiscal" },
        { key: "operationNature", label: "Natureza" },
        { key: "productCode", label: "Produto" },
        { key: "priority", label: "Prioridade" }
      ],
      showModal: false,
      newRule: { rule: "", nature: "", ncm: "", priority: "" },
      regra: {
        nome: ""
      },
      menu: {
        options: [
          { value: "1", text: "Simples" },
          { value: "2", text: "Variação" },
          { value: "3", text: "Kit Prod." }
        ],
        value: "1"
      },

      alert: {
        error: "Verifique os dados informados",
        success: "Produto cadastrado com sucesso!"
      }
    };
  },
  computed: {
    totalQty() {
      const a = this.product.availableQty || 0;
      const r = this.product.reservedQty || 0;
      return a + r;
    }
  },

  methods: {
    addTaxRuleNcm(obj) {
      this.product.taxRulesNcm.push(obj);
    },
    addTaxRuleProduct(obj) {
      this.product.taxRulesProduct.push(obj);
    },
    togglePanel() {
      this.openPanel = !this.openPanel;
    },
    togglePanelTaxRuleProd() {
      this.openTaxRuleProdPanel = !this.openTaxRuleProdPanel;
    },
    closePanel() {
      this.openPanel = false;
    },
    closeTaxRuleProdPanel() {
      this.openTaxRuleProdPanel = false;
    },
    handleInputChange(newValue) {
      this.fetchData();
      if (newValue == null) {
        this.menu.value = this.previousMenuValue;
      } else {
        this.previousMenuValue = newValue;
      }
    },
    getAllProductFamilies() {
      this.$apiScheduler
        .get("/productFamily/list")
        .then(response => {
          response.data.forEach(dataValue => {
            this.productFamilyOptions.push({
              value: dataValue.id,
              text: dataValue.name
            });
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    async addNewProductFamily() {
      const response = await this.$apiScheduler.post(
        "/productFamily/create",
        this.newProductFamily
      );
      this.productFamilyOptions.push({
        value: response.data.id,
        text: response.data.name
      });
      this.product.productFamilyId = response.data.id;
    },
    addNewProduct() {
      const validationErrors = this.validateProduct();

      if (validationErrors.length) {
        this.alert.error = validationErrors[0];
        this.$refs.fadeAlertDanger.show();
        return;
      }

      const url = this.$route.params.edit ? "/product/edit" : "/product/create";

      this.$apiScheduler
        .post(url, this.product)
        .then(response => {
          this.$refs.successFadeAlert.show();
          this.cleanProduct();
        })
        .catch(error => {
          this.alert.error = error.response.data.split("-")[0];
          this.$refs.fadeAlertDanger.show();
        });
    },

    validateProduct() {
      const errors = [];

      if (!this.product.code || !this.product.code.trim()) {
        errors.push("Por favor, insira um código.");
      }

      if (!this.product.price == null || this.product.price < 0) {
        debugger;
        errors.push("Por favor, insira um preço válido.");
      }
      if (!this.product.productType) {
        errors.push("Por favor, selecione o Tipo do Produto.");
      }
      if (!this.totalQty || this.totalQty <= 0) {
        errors.push(
          "Por favor, adicione pelo menos uma quantidade, reservada ou disponível"
        );
      }

      return errors;
    },
    cleanProduct() {
      this.product = {
        id: null,
        name: "",
        code: "",
        barCode: "",
        price: 0,
        unit: "",
        description: "",
        availableQty: 0,
        reservedQty: 0,
        totalQty: 0,
        productFamilyId: null,
        category: "",
        cost: 0,
        type: 0,
        sku: "6",
        cest: "",
        ncm: "",
        productType: null,
        origin: 0,
        taxRulesNcm: [],
        taxRulesProduct: []
      };
    },
    async getAllStates() {
      try {
        const response = await this.$apiScheduler.get(`/system/state/1`);
        this.stateOptions = [...response.data];
      } catch (error) {
        console.error("Erro ao carregar estados:", error);
      }
    }
  },
  mounted() {
    this.getAllStates();
  }
};
</script>

<style scoped>
.top-menu {
  display: flex;
  gap: 10px;
}
</style>
